import { render, staticRenderFns } from "./SelectClientPanel.vue?vue&type=template&id=b0caf728&scoped=true&"
import script from "./SelectClientPanel.vue?vue&type=script&lang=ts&"
export * from "./SelectClientPanel.vue?vue&type=script&lang=ts&"
import style0 from "./SelectClientPanel.vue?vue&type=style&index=0&id=b0caf728&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0caf728",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VRadio,VRadioGroup,VRow,VTextField})
